const CardBadge = ({ badgeText }: { badgeText: string }) => {
  // rendering card badge component here
  return (
    <div className='flex items-center justify-center gap-1 text-xs border-2 border-legal-dark-green px-2 py-px rounded-full text-legal-dark-green font-medium capitalize'>
      <div className='size-2 rounded-full bg-legal-dark-green'></div>
      <p className='font-semibold'>{badgeText}</p>
    </div>
  );
};

export default CardBadge;
